import React from "react";
import { Route, Switch } from "react-router-dom";

// pages
import NotFound from "./components/NotFound";
import Landing from "./components/Landing";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import Staff from "./components/Staff";
import Rota from "./components/Rota";
import AppManager from "./components/Management";
import SecuredRoute from "./util/SecuredRoute";
import Patient from "./components/Patient";
import ChangeSite from "./components/Home/ChangeSite";
import NewPasswordForm from "./components/NewPasswordForm";
import ConfirmRemoval from "./components/ConfirmRemoval";
// import toast
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import YourAppointment from "./components/Appointment/YourAppointment";
// datetime
import "react-datepicker/dist/react-datepicker.css";
import "suneditor/dist/css/suneditor.min.css";

const StartUp = () => {
  return (
    <>
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/home/appointment" component={YourAppointment} />
        <Route path="/login" component={Login} />
        <Route path="/account/new-password" component={NewPasswordForm} />

        <SecuredRoute path="/home/clinical-note" component={Landing} />
        <SecuredRoute path="/home/patient" component={Patient} />
        <SecuredRoute path="/home/staffing" component={Staff} />
        <SecuredRoute path="/home/rota" component={Rota} />
        <SecuredRoute path="/home/app-management" component={AppManager} />
        {/* <SecuredRoute path="/home/training" component={Training} /> */}
        {/* <SecuredRoute path="/home/qr-code/:id" component={QRCodePage} /> */}
        <Route path="/reset-password" component={ForgotPassword} />
        <SecuredRoute path="/home/update-site" component={ChangeSite} />
        <SecuredRoute path="/home/re-auth" component={ConfirmRemoval} />
        <Route component={NotFound} />
      </Switch>
      <ToastContainer position="top-center" />
    </>
  );
};

export default StartUp;
